import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as _ from 'underscore';
  import { useTooltip } from 'Composables/useTooltip';
  import { onMounted, ref } from 'vue';
  import { JBoxDropDown } from 'Core/Components/JBoxDropdown/DropDown';
  import { VueApp } from 'VueApp';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SubQueryTitleEditor',
  props: {
    target: {},
    title: {}
  },
  emits: ["changed", "unmount"],
  setup(__props: any, { emit: __emit }) {

  const props = __props;

  const emit = __emit;

  const title = ref<string>(props.title || '');
  const containerRef = ref<HTMLElement>();
  let tooltipInstance;

  const handleChangeTitle = (event) => {
    event.target.value;
  };

  const handleSaveBtnClick = () => {
    tooltipInstance.Close();
    emit('changed', title.value);
  };

  const handleCancelBtnClick = () => {
    tooltipInstance.Close();
  };

  onMounted(() => {
    const { tooltip } = useTooltip({
      target: props.target,
      onClose: () => {
        emit('unmount');
      },
    });

    tooltipInstance = tooltip;

    tooltip.SetContent({ content: containerRef.value });
    tooltip.Open();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "form-inline"
  }, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
      type: "text",
      class: "form-control input-medium",
      autofocus: "",
      onInput: handleChangeTitle,
      onKeydown: [
        _withKeys(handleSaveBtnClick, ["enter"]),
        _withKeys(handleCancelBtnClick, ["esc"])
      ]
    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
      [_vModelText, title.value]
    ]),
    _createElementVNode("a", {
      class: "btn btn-icon-ony",
      onClick: handleSaveBtnClick
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */)
    ]))]),
    _createElementVNode("a", {
      class: "btn btn-icon-ony",
      onClick: handleCancelBtnClick
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "fa fa-close" }, null, -1 /* CACHED */)
    ]))])
  ], 512 /* NEED_PATCH */))
}
}

})